import React, {memo} from 'react';
import styled from 'styled-components';
import {useTscTheme} from '../../../context/themeProvider';
import {TscThemeNames, TscThemeName} from '@techsmith/tsc-cloud-style-guide';

const CommentEmptyState = styled.div<{theme: TscThemeNames}>`
   box-sizing: border-box;
   --comment-background: ${props => props.theme === TscThemeName.dusk ? 'rgba(255, 255, 255, 0.03)' : 'rgba(255, 255, 255, 0.2)'};
   --comment-border: ${props => props.theme === TscThemeName.dusk ? 'rgba(255, 255, 255, 0.07)' : 'rgb(255, 255, 255)'};
   --content-fill: ${props => props.theme === TscThemeName.dusk ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.07)'};
   --comment-shadow: ${props => props.theme === TscThemeName.dusk ? '0px 4px 16px 0px rgba(0, 0, 0, 0.04), inset 0px 0px 8px 0px rgba(255, 255, 255, 0.05), 0px 1px 3px 0px rgba(0, 0, 0, 0.1)' : '0px 4px 16px 0px rgba(0, 0, 0, 0.04), inset 0px 0px 12px 0px rgba(255, 255, 255, 1), 0px 0.5px 3px 0px rgba(0, 0, 0, 0.06)'};
   width: 100%;
   max-width: 235px;
   position: relative;
   aspect-ratio: 2.5/1;
   overflow: visible;
`;

const CommentTop = styled.div`
   top: 0;
   left: 0;
   box-sizing: border-box;
   border: 1px solid var(--comment-border);
   background: var(--comment-background);
   height: 66%;
   width: 87%;
   position: absolute;
   border-radius: 12px;
   display: flex;
   align-items: flex-start;
   padding: 4% 6% 3% 6%;
   box-shadow: var(--comment-shadow);
`;

const Avatar = styled.div`
   box-sizing: border-box;
   width: 12%;
   background: var(--content-fill);
   margin-right: 5%;
   aspect-ratio: 1/1;
   border-radius: 100%;
   flex: none;
`;

const Content = styled.div`
   box-sizing: border-box;
   display: flex;
   flex-direction: column;
   height: 70%;
   width: 100%;
   margin-top: 2.5%;
   gap: 20%;
`;

const Line = styled.div`
   box-sizing: border-box;
   width: 100%;
   height: 50%;
   border-radius: 12px;
   display: grid;
   grid-template-columns: auto 20%;
   gap: 7.5%;
 
   &:nth-child(2n) {
      grid-template-columns: 35% auto;
   }

   &:before, &:after {
      content: "";
      display: block;
      background: var(--content-fill);
      height: 100%;
      width: 100%;
      border-radius: 9999rem;
   }
`;

const CommentBottom = styled.div`
   box-sizing: border-box;  
   bottom: 0;
   right: 0;
   box-sizing: border-box;
   border: 1px solid var(--comment-border);
   background: var(--comment-background);
   height: 66%;
   width: 87%;
   position: absolute;
   border-radius: 12px;
   backdrop-filter: blur(16px);
   display: flex;
   align-items: flex-start;
   padding: 4% 6% 3% 6%;
   box-shadow: var(--comment-shadow);
`;

export const ConversationEmptyState: React.FC = () => {
   const theme = useTscTheme();

   return (
      <CommentEmptyState theme={theme}>
         <CommentTop>
            <Avatar />
            <Content>
               <Line />
               <Line />
            </Content>
         </CommentTop>
         <CommentBottom>
            <Avatar />
            <Content>
               <Line />
               <Line />
            </Content>
         </CommentBottom>
      </CommentEmptyState>
   );
};

export default memo(ConversationEmptyState);
